import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Node } from 'modules/workflows/types';
import { EdgeModel } from 'ui/workflows/flowchart/types';
import { FLOWCHART_Z_INDEXES } from '../../WorkflowFlowchart/WorkflowFlowchart.styles';
import { JourneyPreview } from '../../JourneyPreview';
import { LoadingOverlay } from '../../LoadingOverlay';

export const LOADING_OVERLAY_ID = 'loading-overlay';

const StyledDiv = styled.div`
  position: relative;
`;

const ChartWrapper = styled.div`
  z-index: ${FLOWCHART_Z_INDEXES.CANVAS};
  position: relative;
  border-radius: ${spacing.quarter};
  overflow: hidden;
`;

const StyledLoadingOverlay = styled(LoadingOverlay)`
  z-index: ${FLOWCHART_Z_INDEXES.TOOLBAR};
`;

export const TilesetPreview = ({
  nodes = [],
  edges = [],
  isLoading = false,
}: {
  nodes: Node[];
  edges: EdgeModel[];
  isLoading?: boolean;
}) => {
  return (
    <StyledDiv>
      <ChartWrapper>
        <JourneyPreview nodes={nodes} edges={edges} />
        {isLoading && <StyledLoadingOverlay data-test={LOADING_OVERLAY_ID} />}
      </ChartWrapper>
    </StyledDiv>
  );
};
